import { onBlockLoaded } from '@plaudit/frontend-apis';
import { Configurator } from './src/Configurator';

onBlockLoaded({
	blockOrClassName: 'lens-and-lines-lumaprints-integration/lumaprints-product-configurator',
	onAdd(blockRoot) {
		const configurator = new Configurator(blockRoot);
		configurator.init().catch((err) => {
			console.error('[Lumaprints Configurator] Initialisation error:', err);
		});
	},
});
